// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeline_timelineContainer__5A9eC {
  display: flex;
  flex-direction: column;
  position: relative;
  max-width: 100%;
  margin: 0 3rem;
  padding: 2rem 1rem;

  & h2 {
    padding: 5px 0;
    font-family: Inter;
    font-size: 0.9rem;
    font-weight: 700;
  }

  & h6 {
    padding: 5px 0;
    font-family: Inter;
    font-size: 0.9rem;
    font-weight: 500;
  }
}

.timeline_timelineItem__tRy1n {
  display: flex;
  position: relative;
  margin: 2rem 0;
  align-items: center;
}

.timeline_left__l2HEG {
  justify-content: flex-start;
  text-align: right;
}

.timeline_right__g-hhJ {
  justify-content: flex-end;
  text-align: left;
}

.timeline_contentBox__ybeqF {
  width: 460px !important;
}

.timeline_rightHeading__aqSKh {
  width: fit-content !important;
  margin-top: auto;
  margin-left: auto;
  text-align: right;
  position: relative;
  right: 0;
}

.timeline_contentHeading__Wy-cp:nth-of-type(4) {
  text-align: right;
  position: relative;
  right: -200px !important;
}

.timeline_contentHeading__Wy-cp {
  width: fit-content;
  white-space: nowrap;
  /* margin: 0; */
  text-align: start;
  background-color: #ff5c00;
  color: var(--text-color);
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 2;
}

.timeline_title__muZiw {
  margin: 0;
  font-family: Inter;
  font-size: 1.1rem;
  font-weight: 700;
}

.timeline_description__jJOkE {
  padding-top: 0.8rem;
  font-family: Inter;
  font-size: 0.9rem;
  font-weight: 500;
}

.timeline_dot__3ixDR {
  position: absolute;
  width: 30px;
  height: 30px;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ff5c00;
  border: 6px solid rgb(238, 156, 48);
  border-radius: 50%;
  z-index: 3;
}

.timeline_verticalLine__3wr-9 {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
  height: 100%;
  border: 2px solid grey;
  border-image: linear-gradient(to top, #ffffff, orange, white) 1;
  z-index: 1;
}

@media (max-width: 768px) {
  .timeline_timelineContainer__5A9eC {
    padding: 0;
    margin: 0 auto;
  }

  .timeline_contentBox__ybeqF {
    width: 100%;
  }

  .timeline_left__l2HEG,
  .timeline_right__g-hhJ {
    justify-content: center;
    text-align: center;
  }
  .timeline_dot__3ixDR {
    display: none;
  }

  .timeline_verticalLine__3wr-9 {
    display: none;
  }

  .timeline_contentHeading__Wy-cp {
    margin: 0;

  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Timeline/timeline.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;;EAElB;IACE,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,wBAAwB;EACxB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,mCAAmC;EACnC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,+DAA+D;EAC/D,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;;EAEX;AACF","sourcesContent":[".timelineContainer {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  max-width: 100%;\n  margin: 0 3rem;\n  padding: 2rem 1rem;\n\n  & h2 {\n    padding: 5px 0;\n    font-family: Inter;\n    font-size: 0.9rem;\n    font-weight: 700;\n  }\n\n  & h6 {\n    padding: 5px 0;\n    font-family: Inter;\n    font-size: 0.9rem;\n    font-weight: 500;\n  }\n}\n\n.timelineItem {\n  display: flex;\n  position: relative;\n  margin: 2rem 0;\n  align-items: center;\n}\n\n.left {\n  justify-content: flex-start;\n  text-align: right;\n}\n\n.right {\n  justify-content: flex-end;\n  text-align: left;\n}\n\n.contentBox {\n  width: 460px !important;\n}\n\n.rightHeading {\n  width: fit-content !important;\n  margin-top: auto;\n  margin-left: auto;\n  text-align: right;\n  position: relative;\n  right: 0;\n}\n\n.contentHeading:nth-of-type(4) {\n  text-align: right;\n  position: relative;\n  right: -200px !important;\n}\n\n.contentHeading {\n  width: fit-content;\n  white-space: nowrap;\n  /* margin: 0; */\n  text-align: start;\n  background-color: #ff5c00;\n  color: var(--text-color);\n  padding: 1rem;\n  border-radius: 8px;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  z-index: 2;\n}\n\n.title {\n  margin: 0;\n  font-family: Inter;\n  font-size: 1.1rem;\n  font-weight: 700;\n}\n\n.description {\n  padding-top: 0.8rem;\n  font-family: Inter;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.dot {\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #ff5c00;\n  border: 6px solid rgb(238, 156, 48);\n  border-radius: 50%;\n  z-index: 3;\n}\n\n.verticalLine {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 2px;\n  height: 100%;\n  border: 2px solid grey;\n  border-image: linear-gradient(to top, #ffffff, orange, white) 1;\n  z-index: 1;\n}\n\n@media (max-width: 768px) {\n  .timelineContainer {\n    padding: 0;\n    margin: 0 auto;\n  }\n\n  .contentBox {\n    width: 100%;\n  }\n\n  .left,\n  .right {\n    justify-content: center;\n    text-align: center;\n  }\n  .dot {\n    display: none;\n  }\n\n  .verticalLine {\n    display: none;\n  }\n\n  .contentHeading {\n    margin: 0;\n\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timelineContainer": `timeline_timelineContainer__5A9eC`,
	"timelineItem": `timeline_timelineItem__tRy1n`,
	"left": `timeline_left__l2HEG`,
	"right": `timeline_right__g-hhJ`,
	"contentBox": `timeline_contentBox__ybeqF`,
	"rightHeading": `timeline_rightHeading__aqSKh`,
	"contentHeading": `timeline_contentHeading__Wy-cp`,
	"title": `timeline_title__muZiw`,
	"description": `timeline_description__jJOkE`,
	"dot": `timeline_dot__3ixDR`,
	"verticalLine": `timeline_verticalLine__3wr-9`
};
export default ___CSS_LOADER_EXPORT___;
